import React from "react";
// UI Framework
import { toast } from "react-toastify";
import { TableCell, TableRow } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
// Components
import {
  Button,
  DynamicDropdown,
  TextInput,
  Table,
  Loading,
} from "src/Components";
// Services
import {
  deleteBaseAssetValue,
  addBaseAssetVolume,
  getٰVolumeAssetDropdown,
  getRealBaseAssetVolumeConfig,
} from "src/Requests/imePortfolio";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
import { addComma } from "src/helper";
// Types
import {
  BaseAssetVolumeConfig,
  RealBaseAssetVolumeConfig,
} from "src/Interfaces/imePortfolio";

const Setting = () => {
  const [loading, setLoading] = React.useState(false);
  const [baseConfig, setBaseConfig] =
    React.useState<RealBaseAssetVolumeConfig>();
  const [searchParam, setSearchParam] = React.useState(
    {} as BaseAssetVolumeConfig,
  );

  React.useEffect(() => {
    setLoading(true);
    getRealBaseAssetVolumeConfig()
      .then((resp) => setBaseConfig(resp))
      .finally(() => setLoading(false));
  }, []);

  const changeHandler = (name: string, value: any) => {
    setSearchParam({ ...searchParam, [name]: value });
  };

  const clickHandler = () => {
    setLoading(true);
    addBaseAssetVolume(searchParam)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          setSearchParam({} as BaseAssetVolumeConfig);
          getRealBaseAssetVolumeConfig().then((resp) => setBaseConfig(resp));
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };
  return (
    <div className="flex flex-col gap-5">
      <div className="flex gap-5 items-end pl-6 w-full h-full">
        <DynamicDropdown
          dropdown={{
            name: "ticker",
            placeholder: "دسته نمادهای پایه",
          }}
          getData={getٰVolumeAssetDropdown}
          onChange={changeHandler}
          value={searchParam?.ticker}
        />
        <TextInput
          label="حداقل حجم"
          name="value"
          onChange={changeHandler}
          value={searchParam?.value?.toString()}
          kind="number"
        />
        <div className="w-9">
          <Button
            text="ثبت"
            onClick={clickHandler}
            variant="contained"
            className="table-btn"
            loading={loading}
          />
        </div>
      </div>
      <div>
        {loading ? (
          <div className="w-full h-full flex justify-center items-center">
            <Loading className="text-blue-500" />
          </div>
        ) : (
          <Table
            header={<div />}
            body={
              <>
                <TableRow>
                  <TableCell>
                    <div className="text-sm font-bold">عنوان</div>
                  </TableCell>
                  <TableCell>
                    <div className="text-sm font-bold">حجم</div>
                  </TableCell>
                  <TableCell>
                    <div className="text-sm font-bold">عملیات</div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <div className="text-xs text-neutral-700 font-medium">
                      مقدار پیش‌فرض
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="text-xs text-neutral-700 font-medium">
                      {addComma(baseConfig?.defaultvloume ?? 0)}
                    </div>
                  </TableCell>
                  <TableCell />
                </TableRow>
                {baseConfig?.items.map((item) => (
                  <TableRow>
                    <TableCell>
                      <div className="text-xs text-neutral-700 font-medium">
                        {item.ticker}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="text-xs text-neutral-700 font-medium">
                        {addComma(item.value)}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div
                        className="hover:bg-red-100 transition-all rounded p-1"
                        onClick={() => {
                          deleteBaseAssetValue(item.ticker).then(() =>
                            getRealBaseAssetVolumeConfig().then((resp) =>
                              setBaseConfig(resp),
                            ),
                          );
                        }}
                      >
                        <DeleteIcon
                          fontSize="small"
                          className={`cursor-pointer text-red-600 transition-all`}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </>
            }
          />
        )}
      </div>
    </div>
  );
};

export default Setting;
